module.exports = __webpack_public_path__ + "static/PCBanner-BlueMobile-159950ab494332d8b78abe18b91ca418.png";